import { ListItem } from '../../../List';
import { TableFeaturesChildList } from './';

/**
 * TableFeatureItem component
 * Used to display a single feature or tip item, including an optional icon and a nested list of child items.
 * @param {Object} params - The parameters object.
 * @param {Object} params.dataItem - An object representing a single feature or tip item.
 * 
 * @returns {JSX.Element} The rendered TableFeatureItem component.
 */
export const TableFeaturesItem = ({ dataItem }) => (
    <ListItem key={dataItem.key} style={{ marginBottom: '0.5em', marginLeft: '1.5em' }}>
        <li>
            {dataItem.icon && <span style={{ marginRight: 4 }}>{dataItem.icon}</span>}
            <b>{dataItem.heading}</b>{dataItem.description}
        </li>
        {Array.isArray(dataItem.children) && (
            <TableFeaturesChildList childrenData={dataItem.children} />
        )}
        {dataItem.isExport && <br />}
    </ListItem>
);